import { Pipe, PipeTransform } from '@angular/core';
import { ClassroomSummary } from './models/classroom-summary.model';

@Pipe({
  name: 'filterClass',
  pure: false
})

export class FilterClass implements PipeTransform {

  transform(classes: ClassroomSummary[], filter?): any {
    return classes.filter(
        course =>
        (!filter.Meets || (course.Meets && (course.Meets.toLowerCase().startsWith(filter.Meets.toLowerCase()) || (filter.Meets.startsWith('%') && course.Meets.toLowerCase().indexOf(filter.Meets.toLowerCase().substring(1)) > -1)))) &&

        (!filter.Term || (course.Term && (course.Term.toLowerCase().startsWith(filter.Term.toLowerCase()) || (filter.Term.startsWith('%') && course.Term.toLowerCase().indexOf(filter.Term.toLowerCase().substring(1)) > -1)))) &&

        (!filter.CourseSection || (course.CourseSection && (course.CourseSection.toLowerCase().startsWith(filter.CourseSection.toLowerCase()) || (filter.CourseSection.startsWith('%') && course.CourseSection.indexOf(filter.CourseSection.toLowerCase().substring(1)) > -1)))) &&

        (!filter.Course || (course.Course && (course.Course.toLowerCase().startsWith(filter.Course.toLowerCase()) || (filter.Course.startsWith('%') && course.Course.indexOf(filter.Course.toLowerCase().substring(1)) > -1)))) &&

        (!filter.Instructor || (course.Instructor && (course.Instructor.toLowerCase().startsWith(filter.Instructor.toLowerCase()) || (filter.Instructor.startsWith('%') && course.Instructor.indexOf(filter.Instructor.toLowerCase().substring(1)) > -1)))) &&

        (!filter.Room || (course.Room && (course.Room.toLowerCase().startsWith(filter.Room.toLowerCase()) || (filter.Room.startsWith('%') && course.Room.indexOf(filter.Room.toLowerCase().substring(1)) > -1)))) &&

        (!filter.Enrolled || (course.Enrolled && (course.Enrolled.toString().toLowerCase().startsWith(filter.Enrolled.toLowerCase()) || (filter.Enrolled.startsWith('%') && course.Enrolled.toString().indexOf(filter.Enrolled.toLowerCase().substring(1)) > -1)))) &&

        ((filter.AttStatusNone && course.TodaysAttendance == 0) ||
        (filter.AttStatusPartial && course.TodaysAttendance == 1) ||
        (filter.AttStatusAll && (course.TodaysAttendance == 2 || course.TodaysAttendance == 4)) ||
        (filter.AttStatusPerfect && course.TodaysAttendance == 3)) &&

        ((filter.GradingNone && course.TodaysGrading == 0) ||
        (filter.GradingPartial && course.TodaysGrading == 1) ||
        (filter.GradingAll && course.TodaysGrading == 2)) &&

        ((filter.RCGNone && course.GradePostedStatus == 2) ||
        (filter.RCGAll && course.GradePostedStatus == 1) ||
        (filter.RCGEx && (course.GradePostedStatus == 0 || course.GradePostedStatus == 3)))
    );
  }
}